import { render, staticRenderFns } from "./PlayerYingyou.vue?vue&type=template&id=6053c585&"
import script from "./PlayerYingyou.vue?vue&type=script&lang=js&"
export * from "./PlayerYingyou.vue?vue&type=script&lang=js&"
import style0 from "./PlayerYingyou.vue?vue&type=style&index=0&id=6053c585&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports